import formatElapsed from './formatElapsed';
import formatPacificDateTime from './formatPacificDateTime';

/**
 * An instant in Pacific time with its distance from now in parentheses, e.g.
 * `Jun 1, 2026, 1:30 PM PDT (2 days ago)`, for text that cannot carry markup
 * such as an `aria-label` or a `title` attribute. The parenthetical is dropped
 * for an instant that cannot be read, where the absolute half already surfaces
 * the raw text.
 *
 * `now` is injectable for deterministic tests.
 */
export default function formatPacificDateTimeWithElapsed(instant: string | Date, now: Date = new Date()): string {
  const absolute = formatPacificDateTime(instant);
  const elapsed = formatElapsed(instant, now);
  return elapsed === null ? absolute : `${absolute} (${elapsed})`;
}
